import { success, error } from 'redux-saga-requests';
import {
  GET_CUSTOMERS,
  GET_CUSTOMER,
  CREATE_CUSTOMER,
  REMOVE_CUSTOMER,
  UPDATE_CUSTOMER,
} from './types';

const initialState = {
  customers: [],
  customer: null,
  loading: false,
  error: null,
};

const getCustomerId = (customer) => customer?.id ?? customer?.customer_id;
const getCustomersList = (data) => data?.customers ?? data ?? [];
const getCustomerPayload = (data) => data?.customer ?? data;
const idsMatch = (left, right) => String(left) === String(right);

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMERS:
    case GET_CUSTOMER:
    case CREATE_CUSTOMER:
    case REMOVE_CUSTOMER:
    case UPDATE_CUSTOMER:
      return { ...state, error: null, loading: true };

    case success(GET_CUSTOMERS):
      return {
        ...state,
        customers: getCustomersList(action.data),
        loading: false,
      };

    case success(GET_CUSTOMER):
      {
        const customer = getCustomerPayload(action.data);
        const customerId = getCustomerId(customer);

      return {
        ...state,
        customer,
        customers: state.customers.some((item) => idsMatch(getCustomerId(item), customerId))
          ? state.customers.map((item) => (idsMatch(getCustomerId(item), customerId) ? { ...item, ...customer } : item))
          : [...state.customers, customer],
        loading: false,
      };
      }

    case success(CREATE_CUSTOMER):
      return {
        ...state,
        customers: [...state.customers, getCustomerPayload(action.data)],
        loading: false,
      };

    case success(REMOVE_CUSTOMER):
      {
        const requestCustomerId = action?.meta?.requestAction?.customerId;

      return {
        ...state,
        customers: state.customers.filter((customer) => !idsMatch(getCustomerId(customer), requestCustomerId)),
        loading: false,
      };
      }

    case success(UPDATE_CUSTOMER):
      {
        const payloadCustomer = getCustomerPayload(action.data);
        const requestCustomerId = action?.meta?.requestAction?.customerId ?? getCustomerId(payloadCustomer);

      return {
        ...state,
        customers: state.customers.map((customer) => (
          idsMatch(getCustomerId(customer), requestCustomerId)
            ? { ...customer, ...payloadCustomer }
            : customer
        )),
        loading: false,
      };
      }

    case error(GET_CUSTOMERS):
    case error(GET_CUSTOMER):
    case error(CREATE_CUSTOMER):
    case error(REMOVE_CUSTOMER):
    case error(UPDATE_CUSTOMER):
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
